import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import TelegramIcon from '@mui/icons-material/Telegram';
import { Button, Card, CardHeader } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import React from 'react';

function Contacts() {
  return (
    <Card
      sx={{
        mb: 2,
        borderRadius: 2,
        border: (t: Theme) => `1px solid ${t.palette.divider}`,
      }}
    >
      <CardHeader
        subheader="Contacts"
        sx={{
          px: 3,
        }}
        action={
          <>
            <Button
              startIcon={<TelegramIcon />}
              href="https://t.me/sky_alin"
              size="small"
              sx={{ textAlign: 'right'}}
            >
              Telegram
            </Button>
            <Button
              startIcon={<AlternateEmailIcon />}
              href="mailto:sky@alinsky.tech"
              sx={{ textAlign: 'right'}}
            >
              Email
            </Button>
          </>
        }
      />
    </Card>
  );
}

export default Contacts;
